<script>
import {ref} from "vue";
import {useRoute} from "vue-router";
import FreeWorld from "@/assets/js/FreeWorld";
import Swals from "@/assets/js/Swals";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import FooterPage from "@/components/assetComponents/FooterPage.vue";

export default {
  name: "RulesPage",
  components: {FooterPage, LoadingPage},
  setup(){

    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0

    let action = ref(useRoute().params.action)

    let loading = ref(false)

    let text = ref('')


    function load_page() {

      loading.value = true
      FreeWorld.Heisenberg({action: action.value}, 'unit/ruls').then((result) => {

        loading.value = false
        let res = result.data
        text.value = res

      }).catch((result) => {
        loading.value = false
        Swals.Catch(result, load_page)
      })
    }
    load_page()

    return {
      loading,
      text,
      action,
    }

  }
}
</script>

<template>

  <LoadingPage v-if="loading"></LoadingPage>

  <div id="main" :class="loading ? 'activeClass' : '' "  class="bg-main">
    <div class="div-top-arrow max_width bg-color d-flex align-items-center">
      <div class="d-flex align-items-center">
        <p v-if="action == 'ruls'" class="m-0">شرایط و قوانین</p>
        <p v-else-if="action == 'privicy'" class="m-0">حریم خصوصی</p>
        <p v-else class="m-0">درباره ما</p>
        <div onclick="history.back()">
          <img class="svg-arrow" src="../assets/img/back.svg" alt="">
        </div>
      </div>
    </div>
    <br>
    <br>
    <br>

    <div dir="rtl" v-html="text" class="p-body py-3 font-4"></div>

  </div>

  <div id="web" :class="loading ? 'activeClass' : '' "  class="bg-main">
    <div v-if="action === 'ruls'" style="background-color: white" class="rounded-4 font-bold font-color p-3 my-4 w-75 ma-auto">شرایط و قوانین</div>
    <div v-else-if="action === 'about_us'" style="background-color: white" class="rounded-4 font-bold font-color p-3 my-4 w-75 ma-auto">درباره ما</div>
    <div v-else style="background-color: white" class="rounded-4 font-bold font-color p-3 my-4 w-75 ma-auto">حریم خصوصی</div>

    <div dir="rtl" style="height: 85vh" v-html="text" class="p-4 bg-white rounded-4 m-auto w-75 overflow-y-scroll font-4"></div>

    <FooterPage></FooterPage>
  </div>
</template>

<style scoped>

</style>